module.exports = __webpack_public_path__ + "img/print-logo.1ff5897a.png";